import { jwtDecode, JwtPayload } from "jwt-decode";

import { localStorageService } from "../storage";

const STORAGE_KEY_NAME = "ageless-ai-auth-token";

const hasStorage = () => typeof window !== "undefined";

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    if (!decoded.exp) return false;
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const setAuthToken = (token: string): Promise<void> => {
  if (!hasStorage()) return Promise.resolve();
  return localStorageService.setItem(STORAGE_KEY_NAME, token);
};

export const getAuthToken = async (): Promise<string | null> => {
  if (!hasStorage()) return Promise.resolve(null);
  const token = await localStorageService.getItem<string>(STORAGE_KEY_NAME);

  if (token && isTokenExpired(token)) {
    localStorageService.removeItem(STORAGE_KEY_NAME);
    return Promise.resolve(null);
  }
  return Promise.resolve(token);
};

export const isAuthorized = () => Boolean(getAuthToken());

export const removeAuthToken = () => {
  if (!hasStorage()) return;
  localStorageService.removeItem(STORAGE_KEY_NAME);
};

export const buildAuthHeaders = async (headers: HeadersInit = {}) => {
  const token = await getAuthToken();
  if (!token) return headers;
  return { ...headers, Authorization: `Bearer ${token}` };
};
